import { URLConfig } from "../network";
import { AgTechQueryParam, OdQueryParam } from "../enums";
import { helperFunctions } from "../helper";
import NetworkService from "../network/networkService";
import { Observable } from "rxjs";
import { IEntryLevelAllResponse, IRepLevelAllResponse } from "../models";

export const getRepLevel = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<IRepLevelAllResponse> => {
  let url = URLConfig.ObservationGetAllURL("observationBook");
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (response) => {
        const res = response as unknown as IRepLevelAllResponse;
        subscriber.next(res);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while creating a product", error);
      }
    );
  });
};

export const getRepLevelNextPage = (
  nextPageURI: string
): Observable<IRepLevelAllResponse> => {
  let url = URLConfig.ObservationGetAllURL(nextPageURI);

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (response) => {
        const res = response as unknown as IRepLevelAllResponse;
        subscriber.next(res);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while creating a product", error);
      }
    );
  });
};

export const addRepLevelData = (payload: any) => {
  let url = URLConfig.ObservationGetAllURL("observationBook/add-data");
  return new Observable((subscriber) => {
    NetworkService.post(url, payload).then(
      (response) => {
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while creating a product", error);
      }
    );
  });
};

export const updateRepLevelObservation = (payload: any) => {
  let url = URLConfig.ObservationGetAllURL("observationBook/list");
  return new Observable((subscriber) => {
    NetworkService.put(url, payload).then(
      (response) => {
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while creating a product", error);
      }
    );
  });
};

export const getEntryLevel = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<IEntryLevelAllResponse> => {
  let url = URLConfig.ObservationGetAllURL("ratingbook");
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (response) => {
        const res = response as unknown as IEntryLevelAllResponse;
        subscriber.next(res);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while creating a product", error);
      }
    );
  });
};

export const getEntryLevelNextPage = (
  nextPageURI: string
): Observable<IEntryLevelAllResponse> => {
  let url = URLConfig.ObservationGetAllURL(nextPageURI);

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (response) => {
        const res = response as unknown as IEntryLevelAllResponse;
        subscriber.next(res);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while creating a product", error);
      }
    );
  });
};

export const addEntryLevelData = (payload: any) => {
  let url = URLConfig.ObservationGetAllURL("ratingBook/add-data");
  return new Observable((subscriber) => {
    NetworkService.post(url, payload).then(
      (response) => {
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while creating a product", error);
      }
    );
  });
};

export const updateEntryLevel = (payload: any) => {
  let url = URLConfig.ObservationGetAllURL("ratingBook/list");

  return new Observable((subscriber) => {
    NetworkService.put(url, payload).then(
      (response) => {
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while creating a product", error);
      }
    );
  });
};
export const getContentLengthForRepLevel = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.ObservationGetAllURL("observationBook");
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching crops master data:", error);
      });
  });
};

export const getContentLengthForEntryLevel = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.ObservationGetAllURL("ratingBook");
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching crops master data:", error);
      });
  });
};

export const AddData = (requestPayload: any,isEntryLevel:boolean=false): Observable<any> => {
   const observationType = isEntryLevel ? "ratingBook/add-data" : "observationBook/add-data";
  let url = URLConfig.ObservationGetAllURL(observationType)
  return new Observable((subscriber) => {
    NetworkService.post(url, requestPayload).then(
      (response) => {
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while creating a product", error);
      }
    );
  });
};